// extracted by mini-css-extract-plugin
module.exports = {"ResetButton":"ResetButton___2Hesh","loading":"loading___1WOj6"};